import React from 'react';
import { Row, Col } from "reactstrap";
import axios from 'axios';
import appConfig from '../data/appConfig';
const lightIDExist = ["Existing Light Number", "舊燈燈號"];
const checkLightURL = appConfig['appSet']['checkLightURL'];
const memInfoArr = ['信眾編號 Member ID', '姓名 Name', '地址 Address', '城市 City'];

const ReEnter = () => {
    return <a className='btn btn-primary' href='./index.html'>重新登記 Re-Enter</a>
}

const NewlineText = (props) => {
    var str = props.str;
    //console.log(typeof str); // string when it's from props.str; object
    var textTemp = String(str); // although str is tyoe as string, 
    // still it cannot take string function unless cast to String explicitly 
    textTemp = textTemp.split('<br />').map((item, i) => <p key={i}>{item}</p>);
    return <div>{textTemp}</div>;
}

class ValidateLightNumber extends React.Component {
	constructor(props) {
		super(props);
        this.state = { disabled: false }; // disable Light Number ID input if LID is found
        this.state = { lightID: '' };
        this.state = { lightIDValid: 0 }; // rise up to parent indicating if lightID is valid
        this.state = { notLIDMsg: '' };
        this.state = {                    // retrieved member info / light expire date
            mid: '',
            ln: '',
            addr: '',
            city: '',
            expDate: ''
        };
        this.state = { memInfoDisp: '' };
		this.state = {
			vlnS0: 'pt-2 show-it',  // Initial state
			vlnS1e: 'pt-2 hide-it', // Error found after retrieving this Light
			vlnS1s: 'pt-2 hide-it', // Show this Light's info
			vlnS1x: 'pt-2 hide-it', // This Light expired 6 months ago
			vlnS2c: 'pt-2 hide-it', // Confirm this Light
			vlnS2n: 'pt-2 hide-it'  // Not this Light
		};
	}

    // onLightStatus = (lID, lValid=0, setPreview=true, expDate='') => { ... }
    handleLIDChange = (e) => {
		this.setState({lightID: e.target.value});
        this.props.lightStatus(e.target.value); // pass parameters up
	}

    handleConfirmLN = (LID) => { // if the searched Light Number is the one
        this.setState( {disabled: true} ); //disable Light Number ID input
        this.setState({
            vlnS0: 'pt-2 hide-it',
            vlnS1e: 'pt-2 hide-it',
            vlnS1s: 'pt-2 hide-it',
            vlnS1x: 'pt-2 hide-it',
            vlnS2c: 'pt-2 hide-it',
            vlnS2n: 'pt-2 hide-it'
        });
        this.setState({ lightID: LID });
        this.setState({ lightIDValid: 1 });
        this.props.lightStatus(LID, 1, true, this.state.expDate); // pass parameters up
    }

    handleNotThisLN = () => { // if the searched Light Number is not the one
        this.setState( {disabled: true} ); //disable Light Number ID input
        this.setState( {preview: false} );
        this.setState({
            vlnS0: 'pt-2 hide-it',
            vlnS1e: 'pt-2 hide-it',
            vlnS1s: 'pt-2 hide-it',
            vlnS1x: 'pt-2 hide-it',
            vlnS2c: 'pt-2 hide-it',
            vlnS2n: 'pt-2 show-it'
        });
        this.setState({ lightIDValid: 0 });
        this.props.lightStatus('', 0, false); // pass parameters up
    }

	// check with backend server if Light ID exists
	handleLightID = (lightID) => {
		if ( !lightID ) {
			alert(lightIDExist[1] + '必須填 ' + lightIDExist[0] + ' is required');
			return;
		}
        
        let regex = /[RL]\d{2}-\d{2}/;
        if (!regex.test(lightID)) {
            alert('燈號格式 Light number format: Rxx-xx (R01-01) or Lxx-xx (L01-01)');
			return;
        }       

		axios.get(checkLightURL, { params: { light_no: lightID } })
		.then(res => {
			const member = res.data;
            let memInfo = '';
			if ( !member[0]['member_id'] ) {
				memInfo += member[0]['Error'];
                //console.log(memInfo);
                //console.log(typeof memInfo);
                //memInfo = memInfo.replace("<br />", " \\n ");
                // {"\n"}
                this.setState({memInfoDisp: memInfo});
                //console.log(typeof this.state.memInfoDisp);
                this.setState({preview: false});
				this.setState({
                    vlnS0: 'pt-2 hide-it',
				    vlnS1e: 'pt-2 shown-it',
				    vlnS1s: 'pt-2 hide-it',
                    vlnS1x: 'pt-2 hide-it',
				    vlnS2c: 'pt-2 hide-it',
				    vlnS2n: 'pt-2 hide-it'
                });
                this.setState( {disabled: true} ); //disable Light Number ID input
                this.props.lightStatus(lightID, 0, false); // pass parameters up
			} else {
                this.setState({
                    mid: member[0]['member_id'],
                    ln: member[0]['last_name'],
                    addr: member[0]['address'],
                    city: member[0]['city'],
                    expDate: member[0]['expire_date']
                });
                this.setState({memInfoDisp: memInfo});

                // check if the expire date is older than specified length
                var today = new Date();
                var t = this.state.expDate.split(/[- :]/);
                var tempExpDate = new Date(Date.UTC(t[0], t[1]-1, t[2], t[3]+8, t[4], t[5]));
                var diff = today.getTime() - tempExpDate.getTime();
                var days = Math.floor(diff / 1000 / 60 / 60 / 24);
                if ( days > 31 ) { // 61 -> 31 on 1/9/2024
                    // reset to 2 month = 1/6 year = 365/6 = 60.8x on 11/30/2022; 
										// reset to 3 month = 1/4 year = 365/4 = 91 on 5/9/2021; 
                    // if expire date is more than 6 months = 365/2 old
                    this.setState({
                        vlnS0: 'pt-2 hide-it',
                        vlnS1e: 'pt-2 hide-it',
                        vlnS1s: 'pt-2 hide-it',
                        vlnS1x: 'pt-2 show-it',
                        vlnS2c: 'pt-2 hide-it',
                        vlnS2n: 'pt-2 hide-it'
                    });
                } else {
                    this.setState({
                        vlnS0: 'pt-2 hide-it',
                        vlnS1e: 'pt-2 hide-it',
                        vlnS1s: 'pt-2 show-it',
                        vlnS1x: 'pt-2 hide-it',
                        vlnS2c: 'pt-2 hide-it',
                        vlnS2n: 'pt-2 hide-it'
                    });
                }
                this.setState( {disabled: true} ); //disable Light Number ID input
                this.props.lightStatus(lightID, 0, false, this.state.expDate); // pass parameters up
			}
		})
		.catch(function (error) {
			console.log(error);
            alert(error);
            // TTD: need to display to frontend
		});		
  	}

    render() {
        return (
            <Row>
            <Col className="app-sect section-renew text-center">
                <div className="app-sect-title highlight-color">續燈 Renew Light</div>
                <Row>
                    <Col xs="12">
                        <div>
                            {lightIDExist[1]}{" "}
                            <input 
                            type="text"
                            name="light_no"
                            id = "light_no"
                            size="6" 
                            maxLength="6"
                            value={this.state.lightID}
                            onChange={this.handleLIDChange} 
                            placeholder="Light Number" 
                            pattern="[RL]\d\d-\d\d"
                            disabled = {(this.state.disabled)? "disabled" : ""}
                            />
                        </div>
                    </Col>
                </Row>
                <div className={this.state.vlnS0}>
                    <button 
                    type="button" 
                    name="validate_light" 
                    style={{width:'250px'}}
                    onClick={() => this.handleLightID(this.state.lightID)}
                    >確認燈號 Validate Light Number</button>
                </div>
                <div className={this.state.vlnS1e}>
                    <NewlineText str={this.state.memInfoDisp} />
                    Any question contact BAUS at {appConfig['appSet']['contactPhone']}<br />
                    <ReEnter />
                    
                </div>
                <div className={this.state.vlnS1x}>
                    <p>
                        <span className="light-info-title">{memInfoArr[0]}</span>: {this.state.mid}<br />
                        <span className="light-info-title">{memInfoArr[1]}</span>: {this.state.ln}...<br />
                        <span className="light-info-title">{memInfoArr[2]}</span>: {this.state.addr}...<br />
                        <span className="light-info-title">{memInfoArr[3]}</span>: {this.state.city}
                    </p>
                    <p><span style={{color: 'red'}}>{'此燈號已過期超過一個月, 請重點 "新燈 ".'}<br />
                    This Light expired more than 1 month ago. Please start with "New Light".</span><br />
                    <ReEnter /></p>
                </div>
                <div className={this.state.vlnS1s}>
                    <p>
                        <span className="light-info-title">{memInfoArr[0]}</span>: {this.state.mid}<br />
                        <span className="light-info-title">{memInfoArr[1]}</span>: {this.state.ln}...<br />
                        <span className="light-info-title">{memInfoArr[2]}</span>: {this.state.addr}...<br />
                        <span className="light-info-title">{memInfoArr[3]}</span>: {this.state.city}
                    </p>
                    <button 
                    type="button" 
                    name="validate_light" 
                    style={{width:'150px'}}
                    onClick={() => this.handleConfirmLN(this.state.lightID)}
                    >確認 Confirm</button>{" "}
                    <button 
                    type="button" 
                    name="validate_light" 
                    style={{width:'200px'}}
                    onClick={() => this.handleNotThisLN(this.state.lightID)}
                    >非此燈號 Not this one</button>
                </div>
                <div className={this.state.vlnS2c}>
                    <p>{" "}</p>
                </div>
                <div className={this.state.vlnS2n}>
                <p>若不記得燈號 If you don't remember your Light number<br />
                請連絡 Please contact BAUS at {appConfig['appSet']['contactPhone']}<br />
                <ReEnter /></p>
                </div>
            </Col>
            </Row>
        )
    };
};

export default ValidateLightNumber;